import { Button, Dialog, DialogActions, DialogContent } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DialogTitleWithClose } from '../../../shared';
import { useGetSupportCase } from '../../hooks';
import { ISupportCaseDuplicate } from '../../models';
import { DuplicatesTable } from '../duplicates-table/duplicates-table.component';

interface Props {
    isOpen: boolean;
    onClose: () => void;
    supportCaseId: string;
    duplicates: ISupportCaseDuplicate[];
}

export const DuplicatesModal: FC<Props> = ({ isOpen, onClose, supportCaseId, duplicates }) => {
    const { t } = useTranslation();
    const { data: supportCase } = useGetSupportCase(supportCaseId);

    return (
        <Dialog open={isOpen} onClose={onClose} fullWidth maxWidth="lg">
            <DialogTitleWithClose onClose={onClose}>{t('duplicates')}</DialogTitleWithClose>

            <DialogContent>
                <DuplicatesTable onClose={onClose} duplicates={duplicates} supportCase={supportCase} />
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose} type="submit" variant="contained" data-testid="confirm">
                    {t('ok')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
